import { render, staticRenderFns } from "./context-list-item.vue?vue&type=template&id=167b7e94"
import script from "./context-list-item.vue?vue&type=script&lang=js"
export * from "./context-list-item.vue?vue&type=script&lang=js"
import style0 from "./context-list-item.vue?vue&type=style&index=0&id=167b7e94&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports